import React from 'react'

export const SliderIconRight = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
<rect x="35.1211" y="0.699917" width="43" height="43" rx="21.5" transform="rotate(53.1775 35.1211 0.699917)" stroke="white"/>
<path d="M20.4967 30.9339L40.4908 30.4487M40.4908 30.4487L31.2751 21.6697M40.4908 30.4487L31.7118 39.6644" stroke="white" stroke-width="2"/>
</svg>
  )
}
